import { useEffect, useState, useRef } from 'react'

export function useIsMounted() {
  const isMounted = useRef(false)
  useEffect(() => {
    isMounted.current = true
    return () => {
      isMounted.current = false
    }
  }, [])
  return isMounted
}

export function useInputState(initialValue: any) {
  const [value, onChange] = useState(initialValue)

  return [value, (e: any) => onChange(e && e.target ? e.target.value : e)]
}

export function useLockBodyScroll(visible: boolean) {
  useEffect(() => {
    if (visible) {
      // Get original body overflow
      const originalStyle = window.getComputedStyle(document.body).overflow
      // Prevent scrolling on mount
      document.body.style.overflow = 'hidden'
      // Re-enable scrolling when component unmounts
      return () => {
        document.body.style.overflow = originalStyle
      }
    }
  }, [visible])
}
